import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Sidebar from '../Component/Sidebar';
import Header from '../Component/Header';
import Main from '../Component/Main';
import Footer from '../Component/Footer';
import Result from '../Component/Result';

export default function MainPage({ merchantDetails }) {

    const merchantData = { merchantId: `${merchantDetails.MerchantId}`, transactionKey: merchantDetails.TransactionKey, paymentMethods: merchantDetails.PaymentMethods };
    const [isResult, setIsResult] = useState({});

    const getResult = async (data) => {
        setIsResult(data);
    }

    return (
        <>
            <Container className="payment-page-container">
                <Row>
                    <Sidebar merchantDetails={merchantDetails} />
                    <Col md={8} sm={{ order: 2 }} xs={{ order: 1 }}>
                        {isResult.transaction  ?
                            (<>
                                <Result isResult={isResult} />
                            </>) :
                            (<>
                                <Header title="Invoice Payment" businessName={merchantDetails.BusinessName} />
                                <Main merchantData={merchantData} sendResult={getResult} />
                            </>)
                        }
                    </Col>
                </Row>
                <Footer />
            </Container>
        </>
    )
}
